// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__TNce6","buttons":"Footer_buttons__2-MzB"};